export default "__VITE_ASSET__CT75F6Sw__"